import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FormDesignerPage } from '@/pages/forms/designer/FormDesignerPage';

const searchSchema = z.object({
	view: z.enum(['build', 'appearance', 'lead']).default('build').catch('build'),
});

export const Route = createFileRoute('/_authenticated/_app/forms/$formId/designer')({
	component: FormDesignerPage,
	validateSearch: searchSchema,
});
